export default __webpack_public_path__ + "static/media/carousel3.97b13737.png";